module.exports = __webpack_public_path__ + "img/banner_notice_2.8860f818.png";